<script>
</script>

<div class="rule" />

<style lang="scss">
	@import "../main.scss";

	.rule {
		background: #cdcdcd;
		margin-top: 6px;
		margin-bottom: 5px;
		height: 1px;
	}

	// @media (max-width: $raster-width) {
	// 	.rule {
	// 		margin-bottom: 8px;
	// 	}
	// }

	// @media (max-width: $text-width) {
	// 	.rule {
	// 		margin-top: 12px;
	// 		margin-bottom: 7px;
	// 	}
	// }
</style>
